<template>
  <div class="toggle" @click="toggle" :style="styles">
    <img :src="plus" alt="" class="w-100 plus" v-if="!isOpening">
    <img :src="minus" alt="" class="w-100 minus" v-else>
  </div>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    isOpening: {
      type: Boolean,
      default: null
    },
    hideIfOpening: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Function,
      default: () => {}
    },
    position: {
      type: String,
      default: null
    },
    top: {
      type: Number,
      default: null
    },
    left: {
      type: Number,
      default: null
    },
    right: {
      type: Number,
      default: null
    },
    bottom: {
      type: Number,
      default: null
    },
    position2: {
      type: String,
      default: null
    },
    top2: {
      type: Number,
      default: null
    },
    left2: {
      type: Number,
      default: null
    },
    right2: {
      type: Number,
      default: null
    },
    bottom2: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      plus: require('../assets/img/plus.png'),
      minus: require('../assets/img/minus.png'),
    }
  },
  computed: {
    styles() {
      let position = this.position2 !== null && this.isOpening ? this.position2 : this.position

      let styles = {
        position: position
      }
      if(position === 'absolute') {
        if(this.isOpening && this.top2 !== null) {
          styles.top = `${this.top2}%`
        } else if(this.top !== null) {
          styles.top = `${this.top}%`
        }

        if(this.isOpening && this.left2 !== null) {
          styles.left = `${this.left2}%`
        } else if(this.left !== null) {
          styles.left = `${this.left}%`
        }

        if(this.isOpening && this.right2 !== null) {
          styles.right = `${this.right2}%`
        } else if(this.right !== null) {
          styles.right = `${this.right}%`
        }

        if(this.isOpening && this.bottom2 !== null) {
          styles.bottom = `${this.bottom2}%`
        } else if(this.bottom !== null) {
          styles.bottom = `${this.bottom}%`
        }
      }

      if(this.hideIfOpening && this.isOpening) {
        styles.display = 'none'
      }
      return styles;
    }
  },
}
</script>

<style scoped>
.toggle {
  cursor: pointer;
}
</style>